<script lang="ts">
  import clsx from 'clsx';

  const { sizeClass = 'w-full h-full' }: { sizeClass?: string } = $props();
</script>

<svg
  id="Lager_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  version="1.1"
  fill="currentColor"
  stroke="currentColor"
  viewBox="0 0 104.76 104.76"
  class={clsx(sizeClass, 'overflow-hidden align-middle')}
>
  <!-- Generator: Adobe Illustrator 29.5.1, SVG Export Plug-In . SVG Version: 2.1.0 Build 141)  -->
  <defs>
    <style>
      .st1 {
        fill: none;
      }

      .st1,
      .st2 {
        stroke-miterlimit: 10;
        stroke-width: 2.94px;
      }

      .st2 {
        fill: #fff;
        filter: url(#drop-shadow-1);
      }
    </style>
    <filter
      id="drop-shadow-1"
      x="11.19"
      y="2.95"
      width="85.2"
      height="100.56"
      filterUnits="userSpaceOnUse"
    >
      <feOffset dx="1.42" dy="1.42" />
      <feGaussianBlur result="blur" stdDeviation="1.42" />
      <feFlood flood-color="#000" flood-opacity=".5" />
      <feComposite in2="blur" operator="in" />
      <feComposite in="SourceGraphic" />
    </filter>
  </defs>
  <polygon
    class="st2"
    points="71.28 6.07 14.24 6.02 14.24 97.7 90.42 97.7 90.42 26.03 71.28 6.07"
  />
  <path
    d="M71.75,63.34c0-.62-.19-1.11-.61-1.53l-10.25-10.25,9.04-9.1c.34-.34.59-.7.75-1.1.16-.4.24-.81.24-1.25s-.08-.88-.25-1.29c-.16-.41-.41-.78-.74-1.11l-2.91-2.96c-.33-.33-.69-.57-1.1-.73-.85-.34-1.74-.34-2.58,0-.41.16-.78.41-1.11.74l-9.04,9.1-10.3-10.25c-.43-.42-.92-.63-1.55-.64-.61-.03-1.09.17-1.5.58l-6.35,6.35c-.42.42-.61.9-.61,1.53s.19,1.11.61,1.53l10.25,10.25-9.7,9.7c-.12.12-.2.24-.25.37-.06.15-.09.29-.09.44v6.19c0,.33.1.57.31.79s.46.31.79.31h6.19c.15,0,.3-.03.44-.09.14-.05.26-.13.37-.25l9.7-9.7,10.25,10.25c.83.83,2.22.83,3.05,0l6.35-6.35c.42-.42.61-.9.61-1.53ZM65.35,36.28l3.12,3.12-1.55,1.55-3.12-3.12,1.55-1.55ZM35.04,41.44l6.31-6.31,4.01,4.01-1.6,1.6c-.23.23-.34.47-.34.79s.1.55.34.79.45.32.75.31c.33,0,.56-.1.76-.31l1.66-1.66,4.6,4.68-6.24,6.31-10.26-10.2ZM40.5,68.82h-4.61v-4.62l22.51-22.56,4.67,4.67-22.56,22.51ZM63.26,69.65l-10.2-10.26,6.25-6.25,4.66,4.58-1.55,1.65c-.26.26-.36.49-.36.79s.1.53.34.76c.46.47,1.05.47,1.52,0l1.68-1.57,3.99,3.99-6.32,6.31Z"
  />
  <polyline class="st1" points="69.6 6.21 69.63 27.58 89.54 27.45" />
</svg>
